module.exports = __webpack_public_path__ + "img/facebook.9d37b6ef.svg";